import { NavLink, useLocation } from 'react-router-dom';

/**
 * "Feedback" in the top bar, carrying the page it was tapped from, so a
 * problem report arrives saying where it happened. On the feedback page
 * itself it keeps the page they originally came from.
 */
export function FeedbackLink() {
  const { pathname, search } = useLocation();
  const to =
    pathname === '/feedback'
      ? `/feedback${search}`
      : `/feedback?from=${encodeURIComponent(pathname + search)}`;
  return (
    <NavLink to={to} className="topbar-guide">
      Feedback
    </NavLink>
  );
}
